export default __webpack_public_path__ + "static/bwtransport-5-ccd01c6baa4c09bb858f53be89feba18.png";